import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSunReflection = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 179,
	height: 127,
	fill: "none",
	viewBox: "0 0 179 127",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "url(#paint0_linear_16263_2343)",
		d: "M178.03 38a89 89 0 0 1-178 0c0-49.15 39.84-35.5 89-35.5 49.15 0 89-13.65 89 35.5Z"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_16263_2343",
		x1: 89.03,
		x2: 89.03,
		y1: -51,
		y2: 127,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "#FFC14A",
			stopOpacity: .3
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FFC14A",
			stopOpacity: .05
		})]
	}) })]
});
export default SvgSunReflection;
